import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  Environment,
  Divisioni,
  IDivisioniICanModel,
  ModelBoolStr,
  ModelNumICanNavigation,
  ModelNumStr,
  ModelNumStrWithDefault,
  DivisioniICanSeeWithDefault,
  IsError,
} from '../../models/-index';
import { Observable } from 'rxjs';
import { CrudGenericsService } from '../common/crud-generics';

@Injectable()
export class DivisioniService extends CrudGenericsService<Divisioni, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/Divisioni`);
    this.base = `${env.apiUrl}/api/Divisioni/`;
  }
  /*
  Get4Select_BySedeId(id: number): Observable<ModelNumStr> {
    const url =  `${this.base}Get4Select_BySedeId?id=' + id;
    return this.http.get<ModelNumStr>(`${url}`);
  }
*/
  // da ristrutturare:  chiamata solo da  new divisioni ad e divisionni on-create:
  GetFiltered_ModelICanNavigation(div: number): Observable<ModelNumICanNavigation[]> {
    const u = `${this.base}GetFiltered_ModelICanNavigation?id=${div}`;
    return this.http.get<ModelNumICanNavigation[]>(`${u}`);
  }
  GetCurrent_Divisione(): Observable<Divisioni> {
    const u = `${this.base}GetCurrent_Divisione`;
    return this.http.get<Divisioni>(u);
  }

  // sostituisce  get4Selec  si chiama in altro modo perchè normalmente è usata solo da SUPER
  Get4Select_AllAziendeBase(): Observable<ModelNumStr[]> {
    const u = `${this.base}Get4Select_AllAziendeBase`;
    return this.http.get<ModelNumStr[]>(u);
  }

  Get_DivisioniICanSeeModel(): Observable<IDivisioniICanModel[]> {
    const u = `${this.base}Get_DivisioniICanSeeModel`;
    return this.http.get<IDivisioniICanModel[]>(u);
  }
  // get for  select
  Get4Select_DivisioniICanSee(): Observable<ModelNumStr[]> {
    const u = `${this.base}Get4Select_DivisioniICanSee`;
    return this.http.get<ModelNumStr[]>(u);
  }

  // get for  select con la div attiva
  Get4Select_DivisioniICanSee_WithDefaultCurrent(): Observable<DivisioniICanSeeWithDefault> {
    const u = `${this.base}Get4Select_DivisioniICanSee_WithDefaultCurrent`;

    return this.http.get<DivisioniICanSeeWithDefault>(u);
  }
  public Get4Select_DivisioniICanSeeNavigation(): Observable<ModelNumICanNavigation[]> {
    const u = `${this.base}Get4Select_DivisioniICanSeeNavigation`;
    return this.http.get<ModelNumICanNavigation[]>(u);
  }
  Get4Select_DivisioniICanModifyNavigation(): Observable<ModelNumICanNavigation[]> {
    const u = `${this.base}Get4Select_DivisioniICanModifyNavigation`;
    return this.http.get<ModelNumICanNavigation[]>(u);
  }
  // per use specifico e opzionale azb
  public Get4Select_DivisioniUserCanSee(id: string, azb: number = 0): Observable<ModelNumStr[]> {
    const u = `${this.base}Get4Select_DivisioniUserCanSee?id=${id}&azb=${azb}`;
    return this.http.get<ModelNumStr[]>(u);
  }
  // overload restituisce divisioni
  public GetAll_DivisioniUserCanSee(id: string, azb: number = 0, get_all: boolean = false): Observable<Divisioni[]> {
    const u = `${this.base}GetAll_DivisioniUserCanSee?id=${id}&azb=${azb}&get_all=${get_all}`;
    return this.http.get<Divisioni[]>(u);
  }
  // web prima di eventuale cancellazione

  public CheckCanDeleteDivisione(id: number): Observable<IsError> {
    const u = `${this.base}CheckCanDeleteDivisione?id=${id}`;
    return this.http.get<IsError>(u);
  }
  InfoLicMaxDivisioniIsFull(): Observable<ModelBoolStr> {
    const u = `${this.base}InfoLicMaxDivisioniIsFull`;
    return this.http.get<ModelBoolStr>(`${u}`);
  }
  //
}
